export default __webpack_public_path__ + "static/media/footer-top.46f3691f.svg";